/**
 * CustomMainFooter — o rodapé.
 *
 * ORIGEM: esqueleto do tema AdminUX, com o botão de "voltar ao topo" que ele
 * traz. Leva `Custom` pela mesma regra dos outros dois: o casco é nosso.
 * Original em `theme/adminux-react/src/components/MainFooter.tsx`.
 */
import React, { useEffect, useState } from 'react';

const CustomMainFooter: React.FC = () => {
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowScrollTop(window.pageYOffset > 100);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  return (
    <>
      {/* rodapé enxuto */}
      {/* A faixa azul com o nome do app NÃO aparece no celular — decisão dele
          em 25/08, olhando o print: *"não tem necessidade de aparecer no
          celular"*. Ela quebrava em duas linhas ("Casa A — operação · Búzios /
          Trancoso") e comia um pedaço da tela logo acima da barra de atalhos,
          para dizer o nome do app que a pessoa acabou de abrir.

          `d-none d-lg-block`, e não a remoção do componente: o botão de voltar
          ao topo mora aqui e continua valendo em qualquer tela.

          ⚠️ O CANTO DIREITO DESTE RODAPÉ FICA VAZIO DE PROPÓSITO (27/08/2026).
          Havia ali um `webapp-caa-ops` — o nome do REPOSITÓRIO, não do produto —
          e o botão da aquarela do tema, que é `position-fixed bottom-0 end-0`,
          caía POR CIMA dele: dois elementos independentes disputando o mesmo
          pixel. O texto saiu em vez de andar para a esquerda, porque não servia
          a ninguém que usa o app: a faixa ao lado já diz o que ele é, e quem
          precisa do identificador técnico tem a URL.

          Se um dia algo voltar a este canto, que seja a VERSÃO DO BUILD — é a
          primeira pergunta de qualquer suporte, e aí o espaço se paga. Mas
          lembre que a aquarela continua flutuando aqui: o que entrar precisa
          caber à esquerda dela. */}
      <footer className="adminuiux-footer has-adminuiux-sidebar mt-auto bg-theme-1 d-none d-lg-block">
        <div className="container-fluid">
          <div className="row gx-3 gx-lg-4">
            <div className="col py-2">
              <span className="small text-white">
                Casa A — operação · Búzios / Trancoso
              </span>
            </div>
          </div>
        </div>
      </footer>

      {/* botão de tema (escolher cor) + voltar ao topo */}
      <div
        className="position-fixed bottom-0 end-0 m-3 z-index-5 fixedbuttons"
        id="fixedbuttons"
      >
        <button
          className="btn btn-square btn-theme shadow rounded-circle"
          type="button"
          data-bs-toggle="offcanvas"
          data-bs-target="#theming"
          aria-controls="theming"
        >
          <i className="bi bi-palette"></i>
        </button>
        <br />
        {showScrollTop && (
          <button
            onClick={scrollToTop}
            className="btn btn-theme btn-square shadow mt-2 rounded-circle theme-black"
          >
            <i className="bi bi-arrow-up"></i>
          </button>
        )}
      </div>
    </>
  );
};

export default CustomMainFooter;
